import { type FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import { useScrollCarousel } from 'dibs-scroll-carousel/exports/ScrollCarouselContext.ts';
import cn from 'classnames';
import dibsCss from 'dibs-css';

import styles from './HeroCarouselCounter.module.css';

export const HeroCarouselCounter: FC = () => {
    const { activeSlide, totalSlides } = useScrollCarousel();

    return (
        <div
            className={cn(
                styles.counter,
                dibsCss.absolute,
                dibsCss.bottomXsmall,
                dibsCss.rightXsmall,
                dibsCss.pyXxxsmall,
                dibsCss.pxXsmall,
                dibsCss.roundedFull,
                dibsCss.zBump,
                dibsCss.sassyFontBodySmall
            )}
            data-tn="pdp-image-carousel-counter"
        >
            <FormattedMessage
                id="HeroCarouselCounter"
                defaultMessage="{activeSlide} of {totalSlides}"
                values={{ activeSlide, totalSlides }}
            />
        </div>
    );
};
